

























































import 'reflect-metadata'
import { Vue, Component, Prop } from 'vue-property-decorator'
import CopyText from '@/components/misc/CopyText.vue'
import { getMappingForType } from '@/store/modules/transactions/maps'
import { toAVAX } from '@/helper'
import Tooltip from '@/components/rows/Tooltip.vue'
import EVMMetadata from '@/components/Transaction/EVMMetadata.vue'
import EVMExecutionTrace from '@/components/Transaction/EVMExecutionTrace.vue'
import EVMLogRow from '@/components/rows/EVMLogRow.vue'

@Component({
    components: {
        Tooltip,
        CopyText,
        EVMMetadata,
        EVMExecutionTrace,
        EVMLogRow,
    },
    filters: {
        getType: getMappingForType,
        toAVAX,
    },
})
export default class EVMTxSummary extends Vue {
    @Prop() tx!: any

    copy() {
        navigator.clipboard.writeText(this.tx.id)
        this.$store.dispatch('Notifications/add', {
            title: 'Copied',
            message: 'Copied to clipoard.',
        })
    }

    get tab() {
        return this.$route.query.tab
    }

    set tab(tab: string | (string | null)[]) {
        this.$router.replace({ query: { ...this.$route.query, tab } })
    }

    get hasTraces() {
        return this.tx.traces.length > 0 ? true : false
    }

    get hasTransfers() {
        return this.tx.transfers.length > 0 ? true : false
    }

    get hasLogs() {
        return this.tx.logs.length > 0 ? true : false
    }
}
